import { Notyf } from 'notyf';

export default class Notification {
  init(res) {
    this.notyf = new Notyf();

    if (res.status === false) {
      this.notyf.error(res.message);
    } else {
      this.notyf.success(res.message);
    }
  }
}
